<template>
  <div class="page-container">
    <div class="background"></div>
    <div class="page-content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.page-container {
  position: relative;
  padding: 64px 56px;
  box-shadow: 0px 8px 28px -6px rgba(24, 39, 75, 0.12),
    0px 18px 88px -4px rgba(24, 39, 75, 0.14);
  border-radius: 16px;

  @include media-breakpoint-down(md) {
    padding: 32px 24px;
  }

  .background {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(4px);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 16px;
  }

  .page-content {
    position: relative;
  }
}
</style>
